import { RichUtils } from 'draft-js';

export default function(style) {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, style));
};



// WEBPACK FOOTER //
// ./src/tools/toggle-inline-style.js